export const AssetSettingsEntities = {
    status: {
        name: "Asset Status",
        key: "asset_statuses",
        responseKey: "asset_statuses",
        apiBodyParam: "asset_status",
        permissionKey: "asset_status",
        tableConfig: {
            keys: ["name", "client", "description", "created_at", "updated_at"],
            config: {
                name: {
                    isVisible: true,
                    label: "Name",
                    class: "",
                    searchKey: "asset_statuses.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_statuses",
                    commonSearchKey: "asset_statuses",
                    commonSearchObjectKey: "name"
                },
                client: {
                    isVisible: true,
                    label: "Client",
                    searchKey: "clients.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "client",
                    commonSearchKey: "clients",
                    commonSearchObjectKey: "name"
                },
                description: {
                    isVisible: true,
                    label: "Description",
                    class: "",
                    searchKey: "description",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_statuses",
                    commonSearchKey: "asset_statuses",
                    commonSearchObjectKey: "description"
                },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "",
                    searchKey: "asset_statuses.created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_statuses",
                    commonSearchKey: "asset_statuses",
                    commonSearchObjectKey: "created_at"
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "",
                    searchKey: "asset_statuses.updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_statuses",
                    commonSearchKey: "asset_statuses",
                    commonSearchObjectKey: "updated_at"
                }
            }
        }
    },
    type: {
        name: "Asset Type",
        key: "asset_types",
        responseKey: "asset_types",
        apiBodyParam: "asset_type",
        permissionKey: "asset_types",
        tableConfig: {
            keys: ["name", "client", "description", "created_at", "updated_at"],
            config: {
                name: {
                    isVisible: true,
                    label: "Name",
                    class: "",
                    searchKey: "asset_types.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_types",
                    commonSearchKey: "asset_types",
                    commonSearchObjectKey: "name"
                },
                client: {
                    isVisible: true,
                    label: "Client",
                    searchKey: "clients.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "client",
                    commonSearchKey: "clients",
                    commonSearchObjectKey: "name"
                },
                description: {
                    isVisible: true,
                    label: "Description",
                    class: "",
                    searchKey: "description",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_types",
                    commonSearchKey: "asset_types",
                    commonSearchObjectKey: "description"
                },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "",
                    searchKey: "asset_types.created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_types",
                    commonSearchKey: "asset_types",
                    commonSearchObjectKey: "created_at"
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "",
                    searchKey: "asset_types.updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_types",
                    commonSearchKey: "asset_types",
                    commonSearchObjectKey: "updated_at"
                }
            }
        }
    },
    condition: {
        name: "Asset Condition",
        key: "client_asset_conditions",
        responseKey: "asset_conditions",
        apiBodyParam: "client_asset_condition",
        permissionKey: "asset_conditions",
        tableConfig: {
            keys: ["name", "client", "description", "color_code", "score", "created_at", "updated_at"],
            config: {
                name: {
                    isVisible: true,
                    label: "Name",
                    class: "",
                    searchKey: "client_asset_conditions.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "client_asset_conditions",
                    commonSearchKey: "client_asset_conditions",
                    commonSearchObjectKey: "name"
                },
                client: {
                    isVisible: true,
                    label: "Client",
                    searchKey: "clients.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "client",
                    commonSearchKey: "clients",
                    commonSearchObjectKey: "name"
                },
                description: {
                    isVisible: true,
                    label: "Description",
                    class: "",
                    searchKey: "description",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "",
                    commonSearchKey: "",
                    commonSearchObjectKey: "",
                    isTextArea: true
                },
                color_code: {
                    isVisible: true,
                    label: "Color",
                    class: "width-140px",
                    searchKey: "client_asset_conditions.color_code",
                    type: "string",
                    hasWildCardSearch: false,
                    hasCommonSearch: false,
                    getListTable: "client_asset_conditions",
                    commonSearchKey: "client_asset_conditions",
                    commonSearchObjectKey: "color_code"
                },
                score: {
                    isVisible: true,
                    label: "Score",
                    class: "",
                    searchKey: "client_asset_conditions.score",
                    type: "number",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "client_asset_conditions",
                    commonSearchKey: "client_asset_conditions",
                    commonSearchObjectKey: "score"
                },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "",
                    searchKey: "client_asset_conditions.created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "client_asset_conditions",
                    commonSearchKey: "client_asset_conditions",
                    commonSearchObjectKey: "created_at"
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "",
                    searchKey: "client_asset_conditions.updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "client_asset_conditions",
                    commonSearchKey: "client_asset_conditions",
                    commonSearchObjectKey: "updated_at"
                }
            }
        }
    },
    manufacturer: {
        name: "Asset Manufacturer",
        key: "manufacturers",
        responseKey: "asset_manufactures",
        apiBodyParam: "manufacturers",
        permissionKey: "manufacturers",
        tableConfig: {
            keys: ["name", "client", "description", "created_at", "updated_at"],
            config: {
                name: {
                    isVisible: true,
                    label: "Name",
                    class: "",
                    searchKey: "asset_manufacturers.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "asset_manufacturers.name",
                    commonSearchKey: "manufacturers",
                    commonSearchObjectKey: "name"
                },
                client: {
                    isVisible: true,
                    label: "Client",
                    searchKey: "clients.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "clients.name",
                    commonSearchKey: "clients",
                    commonSearchObjectKey: "name"
                },
                description: {
                    isVisible: true,
                    label: "Description",
                    class: "",
                    searchKey: "asset_manufacturers.description",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "asset_manufacturers.description",
                    commonSearchKey: "manufacturers",
                    commonSearchObjectKey: "description"
                },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "",
                    searchKey: "asset_manufacturers.created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "manufacturers",
                    commonSearchKey: "manufacturers",
                    commonSearchObjectKey: "created_at"
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "",
                    searchKey: "asset_manufacturers.updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "manufacturers",
                    commonSearchKey: "manufacturers",
                    commonSearchObjectKey: "asset_updated_at"
                }
            }
        }
    },
    pie_chart: {
        name: "End of Useful Service Life",
        key: "asset_chart_colors",
        responseKey: "chart_colors",
        apiBodyParam: "asset_chart_colors",
        permissionKey: "asset_chart_color",
        tableConfig: {
            keys: ["client", "expired", "next_year", "two_years", "three_to_five", "six_to_ten", "ten_plus", "unknown"],
            config: {
                client: {
                    isVisible: true,
                    label: "Client",
                    class: "width-200px",
                    searchKey: "asset_chart_colors.client",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_chart_colors",
                    commonSearchKey: "asset_chart_colors",
                    commonSearchObjectKey: "name"
                },
                next_year: {
                    isVisible: true,
                    label: "Next Year",
                    class: "width-100px",
                    searchKey: "asset_chart_colors.next_year",
                    type: "string",
                    hasWildCardSearch: false,
                    hasCommonSearch: false,
                    getListTable: "asset_chart_colors",
                    commonSearchKey: "asset_chart_colors",
                    commonSearchObjectKey: "next_year"
                },
                two_years: {
                    isVisible: true,
                    label: "2 Years",
                    class: "width-100px",
                    searchKey: "asset_chart_colors.two_years",
                    type: "string",
                    hasWildCardSearch: false,
                    hasCommonSearch: false,
                    getListTable: "asset_chart_colors",
                    commonSearchKey: "asset_chart_colors",
                    commonSearchObjectKey: "two_years"
                },
                three_to_five: {
                    isVisible: true,
                    label: "3-5 Years",
                    class: "width-100px",
                    searchKey: "asset_chart_colors.three_to_five",
                    type: "string",
                    hasWildCardSearch: false,
                    hasCommonSearch: false,
                    getListTable: "asset_chart_colors",
                    commonSearchKey: "asset_chart_colors",
                    commonSearchObjectKey: "three_to_five"
                },
                six_to_ten: {
                    isVisible: true,
                    label: "6-10 Years",
                    class: "width-100px",
                    searchKey: "asset_chart_colors.six_to_ten",
                    type: "string",
                    hasWildCardSearch: false,
                    hasCommonSearch: false,
                    getListTable: "asset_chart_colors",
                    commonSearchKey: "asset_chart_colors",
                    commonSearchObjectKey: "six_to_ten"
                },
                ten_plus: {
                    isVisible: true,
                    label: "10+ Years",
                    class: "width-100px",
                    searchKey: "asset_chart_colors.ten_plus",
                    type: "string",
                    hasWildCardSearch: false,
                    hasCommonSearch: false,
                    getListTable: "asset_chart_colors",
                    commonSearchKey: "asset_chart_colors",
                    commonSearchObjectKey: "ten_plus"
                },
                unknown: {
                    isVisible: true,
                    label: "Unknown",
                    class: "width-100px",
                    searchKey: "asset_chart_colors.unknown",
                    type: "string",
                    hasWildCardSearch: false,
                    hasCommonSearch: false,
                    getListTable: "asset_chart_colors",
                    commonSearchKey: "asset_chart_colors",
                    commonSearchObjectKey: "unknown"
                },

                expired: {
                    isVisible: true,
                    label: "Expired",
                    class: "width-100px",
                    searchKey: "asset_chart_colors.expired",
                    type: "string",
                    hasWildCardSearch: false,
                    hasCommonSearch: false,
                    getListTable: "asset_chart_colors",
                    commonSearchKey: "asset_chart_colors",
                    commonSearchObjectKey: "expired"
                }
                // color_code: {
                //     isVisible: true,
                //     label: "Color",
                //     class: "",
                //     searchKey: "",
                //     type: "string",
                //     hasWildCardSearch: false,
                //     hasCommonSearch: false,
                //     getListTable: "",
                //     commonSearchKey: "",
                //     commonSearchObjectKey: ""
                // }

                // description: {
                //     isVisible: true,
                //     label: "Description",
                //     class: "",
                //     searchKey: "description",
                //     type: "string",
                //     hasWildCardSearch: true,
                //     hasCommonSearch: false,
                //     getListTable: "client_asset_conditions",
                //     commonSearchKey: "client_asset_conditions",
                //     commonSearchObjectKey: "description"
                // },
                // color_code: {
                //     isVisible: false,
                //     label: "Color",
                //     class: "",
                //     searchKey: "",
                //     type: "string",
                //     hasWildCardSearch: false,
                //     hasCommonSearch: false,
                //     getListTable: "",
                //     commonSearchKey: "",
                //     commonSearchObjectKey: ""
                // },
            }
        }
    },
    mainCategory: {
        name: "Main Category",
        key: "main_categories",
        responseKey: "main_categories",
        apiBodyParam: "main_category",
        permissionKey: "main_category",
        tableConfig: {
            keys: ["name", "client", "created_at", "updated_at"],
            config: {
                name: {
                    isVisible: true,
                    label: "Name",
                    class: "",
                    searchKey: "main_categories.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "main_categories",
                    commonSearchKey: "main_categories",
                    commonSearchObjectKey: "name"
                },
                client: {
                    isVisible: true,
                    label: "Client",
                    searchKey: "clients.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "client",
                    commonSearchKey: "clients",
                    commonSearchObjectKey: "name"
                },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "",
                    searchKey: "main_categories.created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "main_categories",
                    commonSearchKey: "main_categories",
                    commonSearchObjectKey: "created_at"
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "",
                    searchKey: "main_categories.updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "main_categories",
                    commonSearchKey: "main_categories",
                    commonSearchObjectKey: "updated_at"
                }
            }
        }
    },
    subCategory1: {
        name: "Sub Category 1",
        key: "sub_category_1",
        responseKey: "sub_category_1s",
        apiBodyParam: "sub_category_1",
        permissionKey: "sub_category_1",
        tableConfig: {
            keys: ["name", "client", "main_category", "created_at", "updated_at"],
            config: {
                name: {
                    isVisible: true,
                    label: "Name",
                    class: "",
                    searchKey: "sub_category_1.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "sub_category_1",
                    commonSearchKey: "sub_category_1",
                    commonSearchObjectKey: "name"
                },
                client: {
                    isVisible: true,
                    label: "Client",
                    searchKey: "clients.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "client",
                    commonSearchKey: "clients",
                    commonSearchObjectKey: "name"
                },
                main_category: {
                    isVisible: true,
                    label: "Main Category",
                    class: "",
                    searchKey: "main_categories.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "main_categories",
                    commonSearchKey: "main_categories",
                    commonSearchObjectKey: "name"
                },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "",
                    searchKey: "sub_category_1.created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "sub_category_1",
                    commonSearchKey: "sub_category_1",
                    commonSearchObjectKey: "created_at"
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "",
                    searchKey: "sub_category_1.updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "sub_category_1",
                    commonSearchKey: "sub_category_1",
                    commonSearchObjectKey: "updated_at"
                }
            }
        }
    },
    subCategory2: {
        name: "Sub Category 2",
        key: "sub_category_2",
        responseKey: "sub_category_2s",
        apiBodyParam: "sub_category_2",
        permissionKey: "sub_category_2",
        tableConfig: {
            keys: ["name", "client", "main_category", "sub_category_1", "subcategory2_description", "created_at", "updated_at"],
            config: {
                name: {
                    isVisible: true,
                    label: "Name",
                    class: "",
                    searchKey: "sub_category_2.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "sub_category_2",
                    commonSearchKey: "sub_category_2",
                    commonSearchObjectKey: "name"
                },
                client: {
                    isVisible: true,
                    label: "Client",
                    searchKey: "clients.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "client",
                    commonSearchKey: "clients",
                    commonSearchObjectKey: "name"
                },
                main_category: {
                    isVisible: true,
                    label: "Main Category",
                    class: "",
                    searchKey: "main_categories.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "main_categories",
                    commonSearchKey: "main_categories",
                    commonSearchObjectKey: "name"
                },
                sub_category_1: {
                    isVisible: true,
                    label: "Sub Category 1",
                    class: "",
                    searchKey: "sub_category_1.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "sub_category_1",
                    commonSearchKey: "sub_category_1",
                    commonSearchObjectKey: "name"
                },
                subcategory2_description: {
                    isVisible: true,
                    label: "Sub Category 2 Description",
                    class: "",
                    searchKey: "subcategory2_description",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "",
                    commonSearchKey: "",
                    commonSearchObjectKey: ""
                },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "",
                    searchKey: "sub_category_2.created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "sub_category_2",
                    commonSearchKey: "sub_category_2",
                    commonSearchObjectKey: "created_at"
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "",
                    searchKey: "sub_category_2.updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "sub_category_2",
                    commonSearchKey: "sub_category_2",
                    commonSearchObjectKey: "updated_at"
                }
            }
        }
    },
    subCategory3: {
        name: "Sub Category 3",
        key: "sub_category_3",
        responseKey: "sub_category_3s",
        apiBodyParam: "sub_category_3",
        permissionKey: "sub_category_3",
        tableConfig: {
            keys: ["name", "client", "main_category", "sub_category_1", "sub_category_2", "created_at", "updated_at"],
            config: {
                name: {
                    isVisible: true,
                    label: "Name",
                    class: "",
                    searchKey: "sub_category_3.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "sub_category_3",
                    commonSearchKey: "sub_category_3",
                    commonSearchObjectKey: "name"
                },
                client: {
                    isVisible: true,
                    label: "Client",
                    searchKey: "clients.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "client",
                    commonSearchKey: "clients",
                    commonSearchObjectKey: "name"
                },
                main_category: {
                    isVisible: true,
                    label: "Main Category",
                    class: "",
                    searchKey: "main_categories.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "main_categories",
                    commonSearchKey: "main_categories",
                    commonSearchObjectKey: "name"
                },
                sub_category_1: {
                    isVisible: true,
                    label: "Sub Category 1",
                    class: "",
                    searchKey: "sub_category_1.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "sub_category_1",
                    commonSearchKey: "sub_category_1",
                    commonSearchObjectKey: "name"
                },
                sub_category_2: {
                    isVisible: true,
                    label: "Sub Category 2",
                    class: "",
                    searchKey: "sub_category_2.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "sub_category_2",
                    commonSearchKey: "sub_category_2",
                    commonSearchObjectKey: "name"
                },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "",
                    searchKey: "sub_category_3.created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "sub_category_3",
                    commonSearchKey: "sub_category_3",
                    commonSearchObjectKey: "created_at"
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "",
                    searchKey: "sub_category_3.updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "sub_category_3",
                    commonSearchKey: "sub_category_3",
                    commonSearchObjectKey: "updated_at"
                }
            }
        }
    },
    level1: {
        name: "Uniformat Level 1",
        key: "uniformat_level_1s",
        responseKey: "uniformat_level_1s",
        apiBodyParam: "uniformat_level_1",
        permissionKey: "uniformat_level_1",
        tableConfig: {
            keys: ["name", "uniformat_version", "created_at", "updated_at"],
            config: {
                name: {
                    isVisible: true,
                    label: "Name",
                    class: "",
                    searchKey: "uniformat_level_1s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_1s",
                    commonSearchKey: "uniformat_level_1s",
                    commonSearchObjectKey: "name"
                },
                uniformat_version: {
                    isVisible: true,
                    label: "Uniformat Version",
                    class: "",
                    searchKey: "uniformat_level_1s.uniformat_version",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_1s",
                    commonSearchKey: "uniformat_level_1s",
                    commonSearchObjectKey: "uniformat_version"
                },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "",
                    searchKey: "uniformat_level_1s.created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_1s",
                    commonSearchKey: "uniformat_level_1s",
                    commonSearchObjectKey: "created_at"
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "",
                    searchKey: "uniformat_level_1s.updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_1s",
                    commonSearchKey: "uniformat_level_1s",
                    commonSearchObjectKey: "updated_at"
                }
            }
        }
    },
    level2: {
        name: "Uniformat level 2",
        key: "uniformat_level_2s",
        responseKey: "uniformat_level_2s",
        apiBodyParam: "uniformat_level_2",
        permissionKey: "uniformat_level_2",
        tableConfig: {
            keys: ["name", "uniformat_level_1", "uniformat_version", "created_at", "updated_at"],
            config: {
                name: {
                    isVisible: true,
                    label: "Name",
                    class: "",
                    searchKey: "uniformat_level_2s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_2s",
                    commonSearchKey: "uniformat_level_2s",
                    commonSearchObjectKey: "name"
                },
                uniformat_level_1: {
                    isVisible: true,
                    label: "Uniformat level 1",
                    class: "",
                    searchKey: "uniformat_level_1s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_1s",
                    commonSearchKey: "uniformat_level_1s",
                    commonSearchObjectKey: "name"
                },
                uniformat_version: {
                    isVisible: true,
                    label: "Uniformat Version",
                    class: "",
                    searchKey: "uniformat_level_2s.uniformat_version",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_2s",
                    commonSearchKey: "uniformat_level_2s",
                    commonSearchObjectKey: "uniformat_version"
                },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "",
                    searchKey: "uniformat_level_2s.created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_2s",
                    commonSearchKey: "uniformat_level_2s",
                    commonSearchObjectKey: "created_at"
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "",
                    searchKey: "uniformat_level_2s.updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_2s",
                    commonSearchKey: "uniformat_level_2s",
                    commonSearchObjectKey: "updated_at"
                }
            }
        }
    },
    level3: {
        name: "Uniformat level 3",
        key: "uniformat_level_3s",
        responseKey: "uniformat_level_3s",
        apiBodyParam: "uniformat_level_3",
        permissionKey: "uniformat_level_3",
        tableConfig: {
            keys: ["name", "uniformat_level_1", "uniformat_level_2", "uniformat_version", "created_at", "updated_at"],
            config: {
                name: {
                    isVisible: true,
                    label: "Name",
                    class: "",
                    searchKey: "uniformat_level_3s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_3s",
                    commonSearchKey: "uniformat_level_3s",
                    commonSearchObjectKey: "name"
                },
                uniformat_level_1: {
                    isVisible: true,
                    label: "Uniformat level 1",
                    class: "",
                    searchKey: "uniformat_level_1s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_1s",
                    commonSearchKey: "uniformat_level_1s",
                    commonSearchObjectKey: "name"
                },
                uniformat_level_2: {
                    isVisible: true,
                    label: "Uniformat level 2",
                    class: "",
                    searchKey: "uniformat_level_2s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_2s",
                    commonSearchKey: "uniformat_level_2s",
                    commonSearchObjectKey: "name"
                },
                uniformat_version: {
                    isVisible: true,
                    label: "Uniformat Version",
                    class: "",
                    searchKey: "uniformat_level_3s.uniformat_version",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_3s",
                    commonSearchKey: "uniformat_level_3s",
                    commonSearchObjectKey: "uniformat_version"
                },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "",
                    searchKey: "uniformat_level_3s.created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_3s",
                    commonSearchKey: "uniformat_level_3s",
                    commonSearchObjectKey: "created_at"
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "",
                    searchKey: "uniformat_level_3s.updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_3s",
                    commonSearchKey: "uniformat_level_3s",
                    commonSearchObjectKey: "updated_at"
                }
            }
        }
    },
    level4: {
        name: "Uniformat level 4",
        key: "uniformat_level_4s",
        responseKey: "uniformat_level_4s",
        apiBodyParam: "uniformat_level_4",
        permissionKey: "uniformat_level_4",
        tableConfig: {
            keys: ["name", "uniformat_level_1", "uniformat_level_2", "uniformat_level_3", "uniformat_version", "created_at", "updated_at"],
            config: {
                name: {
                    isVisible: true,
                    label: "Name",
                    class: "",
                    searchKey: "uniformat_level_4s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_4s",
                    commonSearchKey: "uniformat_level_4s",
                    commonSearchObjectKey: "name"
                },
                uniformat_level_1: {
                    isVisible: true,
                    label: "Uniformat level 1",
                    class: "",
                    searchKey: "uniformat_level_1s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_1s",
                    commonSearchKey: "uniformat_level_1s",
                    commonSearchObjectKey: "name"
                },
                uniformat_level_2: {
                    isVisible: true,
                    label: "Uniformat level 2",
                    class: "",
                    searchKey: "uniformat_level_2s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_2s",
                    commonSearchKey: "uniformat_level_2s",
                    commonSearchObjectKey: "name"
                },
                uniformat_level_3: {
                    isVisible: true,
                    label: "Uniformat level 3",
                    class: "",
                    searchKey: "uniformat_level_3s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_3s",
                    commonSearchKey: "uniformat_level_3s",
                    commonSearchObjectKey: "name"
                },
                uniformat_version: {
                    isVisible: true,
                    label: "Uniformat Version",
                    class: "",
                    searchKey: "uniformat_level_4s.uniformat_version",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_4s",
                    commonSearchKey: "uniformat_level_4s",
                    commonSearchObjectKey: "uniformat_version"
                },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "",
                    searchKey: "uniformat_level_4s.created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_4s",
                    commonSearchKey: "uniformat_level_4s",
                    commonSearchObjectKey: "created_at"
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "",
                    searchKey: "uniformat_level_4s.updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_4s",
                    commonSearchKey: "uniformat_level_4s",
                    commonSearchObjectKey: "updated_at"
                }
            }
        }
    },
    level5: {
        name: "Uniformat level 5",
        key: "uniformat_level_5s",
        responseKey: "uniformat_level_5s",
        apiBodyParam: "uniformat_level_5",
        permissionKey: "uniformat_level_5",
        tableConfig: {
            keys: [
                "name",
                "uniformat_level_5_description",
                "uniformat_level_1",
                "uniformat_level_2",
                "uniformat_level_3",
                "uniformat_level_4",
                "in_scope",
                "asset_eul",
                "asset_unit",
                "uniformat_version",
                "created_at",
                "updated_at"
            ],
            config: {
                name: {
                    isVisible: true,
                    label: "Name",
                    class: "",
                    searchKey: "uniformat_level_5s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_5s",
                    commonSearchKey: "uniformat_level_5s",
                    commonSearchObjectKey: "name"
                },
                uniformat_level_5_description: {
                    isVisible: true,
                    label: "Uniformat level 5 Description",
                    class: "",
                    searchKey: "uniformat_level_5_description",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_5s",
                    commonSearchKey: "uniformat_level_5s",
                    commonSearchObjectKey: "uniformat_level_5_description"
                },
                uniformat_level_1: {
                    isVisible: true,
                    label: "Uniformat level 1",
                    class: "",
                    searchKey: "uniformat_level_1s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_1s",
                    commonSearchKey: "uniformat_level_1s",
                    commonSearchObjectKey: "name"
                },
                uniformat_level_2: {
                    isVisible: true,
                    label: "Uniformat level 2",
                    class: "",
                    searchKey: "uniformat_level_2s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_2s",
                    commonSearchKey: "uniformat_level_2s",
                    commonSearchObjectKey: "name"
                },
                uniformat_level_3: {
                    isVisible: true,
                    label: "Uniformat level 3",
                    class: "",
                    searchKey: "uniformat_level_3s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_3s",
                    commonSearchKey: "uniformat_level_3s",
                    commonSearchObjectKey: "name"
                },
                uniformat_level_4: {
                    isVisible: true,
                    label: "Uniformat level 4",
                    class: "",
                    searchKey: "uniformat_level_4s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_4s",
                    commonSearchKey: "uniformat_level_4s",
                    commonSearchObjectKey: "name"
                },
                in_scope: {
                    isVisible: true,
                    label: "In Scope",
                    class: "",
                    searchKey: "uniformat_level_5s.in_scope",
                    type: "boolean",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_5s",
                    commonSearchKey: "uniformat_level_5s",
                    commonSearchObjectKey: "in_scope"
                },
                asset_eul: {
                    isVisible: true,
                    label: "Asset EUL",
                    class: "",
                    searchKey: "uniformat_level_5s.asset_eul",
                    type: "number",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_5s",
                    commonSearchKey: "uniformat_level_5s",
                    commonSearchObjectKey: "asset_eul"
                },
                asset_unit: {
                    isVisible: true,
                    label: "Asset Unit",
                    class: "",
                    searchKey: "uniformat_level_5s.asset_unit",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_5s",
                    commonSearchKey: "uniformat_level_5s",
                    commonSearchObjectKey: "asset_unit"
                },
                uniformat_version: {
                    isVisible: true,
                    label: "Uniformat Version",
                    class: "",
                    searchKey: "uniformat_level_5s.uniformat_version",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_5s",
                    commonSearchKey: "uniformat_level_5s",
                    commonSearchObjectKey: "uniformat_version"
                },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "",
                    searchKey: "uniformat_level_5s.created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_5s",
                    commonSearchKey: "uniformat_level_5s",
                    commonSearchObjectKey: "created_at"
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "",
                    searchKey: "uniformat_level_5s.updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_5s",
                    commonSearchKey: "uniformat_level_5s",
                    commonSearchObjectKey: "updated_at"
                }
            }
        }
    },
    level6: {
        name: "Uniformat level 6",
        key: "uniformat_level_6s",
        responseKey: "uniformat_level_6s",
        apiBodyParam: "uniformat_level_6",
        permissionKey: "uniformat_level_6",
        tableConfig: {
            keys: [
                "name",
                "uniformat_level_6_description",
                "uniformat_level_1",
                "uniformat_level_2",
                "uniformat_level_3",
                "uniformat_level_4",
                "uniformat_level_5",
                "in_scope",
                "asset_eul",
                "asset_unit",
                "asset_unit_additional",
                "average_criticality",
                "average_business_criticality",
                "average_safety_criticality",
                "average_environment_criticality",
                "in_adc_worksheet",
                "uniformat_version",
                "created_at",
                "updated_at"
            ],
            config: {
                name: {
                    isVisible: true,
                    label: "Name",
                    class: "",
                    searchKey: "uniformat_level_6s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_6s",
                    commonSearchKey: "uniformat_level_6s",
                    commonSearchObjectKey: "name"
                },
                uniformat_level_1: {
                    isVisible: true,
                    label: "Uniformat level 1",
                    class: "",
                    searchKey: "uniformat_level_1s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_1s",
                    commonSearchKey: "uniformat_level_1s",
                    commonSearchObjectKey: "name"
                },
                uniformat_level_2: {
                    isVisible: true,
                    label: "Uniformat level 2",
                    class: "",
                    searchKey: "uniformat_level_2s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_2s",
                    commonSearchKey: "uniformat_level_2s",
                    commonSearchObjectKey: "name"
                },
                uniformat_level_3: {
                    isVisible: true,
                    label: "Uniformat level 3",
                    class: "",
                    searchKey: "uniformat_level_3s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_3s",
                    commonSearchKey: "uniformat_level_3s",
                    commonSearchObjectKey: "name"
                },
                uniformat_level_4: {
                    isVisible: true,
                    label: "Uniformat level 4",
                    class: "",
                    searchKey: "uniformat_level_4s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_4s",
                    commonSearchKey: "uniformat_level_4s",
                    commonSearchObjectKey: "name"
                },
                uniformat_level_5: {
                    isVisible: true,
                    label: "Uniformat level 5",
                    class: "",
                    searchKey: "uniformat_level_5s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_5s",
                    commonSearchKey: "uniformat_level_5s",
                    commonSearchObjectKey: "name"
                },
                uniformat_level_6_description: {
                    isVisible: true,
                    label: "Uniformat level 6 Description",
                    class: "",
                    searchKey: "uniformat_level_6_description",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_6s",
                    commonSearchKey: "uniformat_level_6s",
                    commonSearchObjectKey: "uniformat_level_6_description"
                },
                in_scope: {
                    isVisible: true,
                    label: "In Scope",
                    class: "",
                    searchKey: "uniformat_level_6s.in_scope",
                    type: "boolean",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_6s",
                    commonSearchKey: "uniformat_level_6s",
                    commonSearchObjectKey: "in_scope"
                },
                asset_eul: {
                    isVisible: true,
                    label: "Asset EUL",
                    class: "",
                    searchKey: "uniformat_level_6s.asset_eul",
                    type: "number",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_6s",
                    commonSearchKey: "uniformat_level_6s",
                    commonSearchObjectKey: "asset_eul"
                },
                asset_unit: {
                    isVisible: true,
                    label: "Asset Unit",
                    class: "",
                    searchKey: "uniformat_level_6s.asset_unit",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_6s",
                    commonSearchKey: "uniformat_level_6s",
                    commonSearchObjectKey: "asset_unit"
                },
                asset_unit_additional: {
                    isVisible: true,
                    label: "Asset Unit Additional",
                    class: "",
                    searchKey: "uniformat_level_6s.asset_unit_additional",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_6s",
                    commonSearchKey: "uniformat_level_6s",
                    commonSearchObjectKey: "asset_unit_additional"
                },
                average_criticality: {
                    isVisible: true,
                    label: "Average Criticality",
                    class: "",
                    searchKey: "uniformat_level_6s.average_criticality",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_6s",
                    commonSearchKey: "uniformat_level_6s",
                    commonSearchObjectKey: "average_criticality"
                },
                average_business_criticality: {
                    isVisible: true,
                    label: "Average Business Criticality",
                    class: "",
                    searchKey: "uniformat_level_6s.average_business_criticality",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_6s",
                    commonSearchKey: "uniformat_level_6s",
                    commonSearchObjectKey: "average_business_criticality"
                },
                average_safety_criticality: {
                    isVisible: true,
                    label: "Average Safety Criticality",
                    class: "",
                    searchKey: "uniformat_level_6s.average_safety_criticality",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_6s",
                    commonSearchKey: "uniformat_level_6s",
                    commonSearchObjectKey: "average_safety_criticality"
                },
                average_environment_criticality: {
                    isVisible: true,
                    label: "Average Environmental Criticality",
                    class: "",
                    searchKey: "uniformat_level_6s.average_environment_criticality",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_6s",
                    commonSearchKey: "uniformat_level_6s",
                    commonSearchObjectKey: "average_environment_criticality"
                },
                in_adc_worksheet: {
                    isVisible: true,
                    label: "In ADC Worksheet",
                    class: "",
                    searchKey: "uniformat_level_6s.in_adc_worksheet",
                    type: "boolean",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_6s",
                    commonSearchKey: "uniformat_level_6s",
                    commonSearchObjectKey: "in_adc_worksheet"
                },
                uniformat_version: {
                    isVisible: true,
                    label: "Uniformat Version",
                    class: "",
                    searchKey: "uniformat_level_6s.uniformat_version",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_6s",
                    commonSearchKey: "uniformat_level_6s",
                    commonSearchObjectKey: "uniformat_version"
                },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "",
                    searchKey: "uniformat_level_6s.created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_6s",
                    commonSearchKey: "uniformat_level_6s",
                    commonSearchObjectKey: "created_at"
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "",
                    searchKey: "uniformat_level_6s.updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "uniformat_level_6s",
                    commonSearchKey: "uniformat_level_6s",
                    commonSearchObjectKey: "updated_at"
                }
            }
        }
    },
    asset_scope_worksheets: {
        name: "Asset Scope Worksheet",
        key: "asset_scope_worksheets",
        responseKey: "asset_scope_worksheet",
        apiBodyParam: "asset_scope_worksheets",
        permissionKey: "asset_scope_worksheets",
        tableConfig: {
            keys: [
                "list_name",
                "client_input",
                "in_scope",
                "uniformat_code",
                "uniformat_name",
                "classification",
                "uni_l2",
                "uni_l3",
                "uni_l4",
                "uni_l5",
                "asset_desc",
                "in_master_template",
                "asset_eul",
                "asset_unit",
                "asset_unit_additional",
                "avg_crit",
                "avg_bus_crit",
                "avg_safe_crit",
                "avg_env_crit",
                "created_at",
                "updated_at"
            ],
            config: {
                list_name: {
                    isVisible: true,
                    label: "List Name",
                    class: "width-180px",
                    searchKey: "list_name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "list_name",
                    isRequired: true
                },
                client_input: {
                    isVisible: true,
                    label: "Client Input",
                    class: "width-180px",
                    searchKey: "client_input",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "client_input"
                },
                in_scope: {
                    isVisible: true,
                    label: "In Scope",
                    class: "width-180px",
                    searchKey: "in_scope",
                    type: "boolean",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "in_scope"
                },
                uniformat_code: {
                    isVisible: true,
                    label: "Uniformat Code",
                    class: "width-180px",
                    searchKey: "uniformat_code",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "uniformat_code",
                    isRequired: true
                },
                uniformat_name: {
                    isVisible: true,
                    label: "Uniformat Name",
                    class: "width-180px",
                    searchKey: "uniformat_name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "uniformat_name"
                },
                classification: {
                    isVisible: true,
                    label: "Classification",
                    class: "width-180px",
                    searchKey: "classification",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "classification"
                },
                uni_l2: {
                    isVisible: true,
                    label: "Uni L2",
                    class: "width-180px",
                    searchKey: "uni_l2",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "uni_l2"
                },
                uni_l3: {
                    isVisible: true,
                    label: "Uni L3",
                    class: "width-180px",
                    searchKey: "uni_l3",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "uni_l3"
                },
                uni_l4: {
                    isVisible: true,
                    label: "Uni L4",
                    class: "width-180px",
                    searchKey: "uni_l4",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "uni_l4"
                },
                uni_l5: {
                    isVisible: true,
                    label: "Uni L5",
                    class: "width-180px",
                    searchKey: "uni_l5",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "uni_l5"
                },
                asset_desc: {
                    isVisible: true,
                    label: "Asset Description",
                    class: "width-180px",
                    searchKey: "asset_desc",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "asset_desc"
                },
                in_master_template: {
                    isVisible: true,
                    label: "In Master Template",
                    class: "width-180px",
                    searchKey: "in_master_template",
                    type: "boolean",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "in_master_template"
                },
                asset_eul: {
                    isVisible: true,
                    label: "Asset EUL",
                    class: "width-180px",
                    searchKey: "asset_eul",
                    type: "number",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "asset_eul"
                },
                asset_unit: {
                    isVisible: true,
                    label: "Asset Unit",
                    class: "width-180px",
                    searchKey: "asset_unit",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "asset_unit"
                },
                asset_unit_additional: {
                    isVisible: true,
                    label: "Asset Unit Additional",
                    class: "width-180px",
                    searchKey: "asset_unit_additional",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "asset_unit_additional"
                },
                avg_crit: {
                    isVisible: true,
                    label: "Average Criticality",
                    class: "width-180px",
                    searchKey: "avg_crit",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "avg_crit"
                },
                avg_bus_crit: {
                    isVisible: true,
                    label: "Average Business Criticality",
                    class: "width-180px",
                    searchKey: "avg_bus_crit",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "avg_bus_crit"
                },
                avg_safe_crit: {
                    isVisible: true,
                    label: "Average Safety Criticality",
                    class: "width-180px",
                    searchKey: "avg_safe_crit",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "avg_safe_crit"
                },
                avg_env_crit: {
                    isVisible: true,
                    label: "Average Environmental Criticality",
                    class: "width-180px",
                    searchKey: "avg_env_crit",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "avg_env_crit"
                },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "width-180px",
                    searchKey: "created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "created_at",
                    hideInForm: true
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "width-180px",
                    searchKey: "updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "asset_scope_worksheets",
                    commonSearchKey: "asset_scope_worksheets",
                    commonSearchObjectKey: "updated_at",
                    hideInForm: true
                }
            }
        }
    },
    recommendation_assets_costing_templates: {
        name: "Recommendation and Asset Costing Template",
        key: "recommendation_assets_costing_templates",
        responseKey: "recommendation_assets_costing_templates",
        apiBodyParam: "recommendation_assets_costing_templates",
        permissionKey: "recommendation_assets_costing_templates",
        tableConfig: {
            keys: [
                "line_id",
                "type_fca",
                "type_adc",
                "trade_1",
                "trade_2",
                "l2_code",
                "system",
                "system_l2",
                "average_useful_life_years",
                "uniformat_code_l4",
                "sub_system_l4",
                "uniformat_code_l5",
                "description",
                "unit",
                "unit_cost",
                "regional_adj",
                "regionally_adjusted",
                "action",
                "recommendation_name",
                "recommendation_narrative",
                "created_at",
                "updated_at"
            ],
            config: {
                line_id: {
                    isVisible: true,
                    label: "Line ID",
                    class: "width-180px",
                    searchKey: "line_id",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "line_id",
                    isRequired: true
                },
                type_fca: {
                    isVisible: true,
                    label: "Type FCA",
                    class: "width-180px",
                    searchKey: "type_fca",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "type_fca"
                },
                type_adc: {
                    isVisible: true,
                    label: "Type ADC",
                    class: "width-180px",
                    searchKey: "type_adc",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "type_adc"
                },
                trade_1: {
                    isVisible: true,
                    label: "Trade 1",
                    class: "width-180px",
                    searchKey: "trade_1",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "trade_1"
                },
                trade_2: {
                    isVisible: true,
                    label: "Trade 2",
                    class: "width-180px",
                    searchKey: "trade_2",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "trade_2"
                },
                l2_code: {
                    isVisible: true,
                    label: "L2 Code",
                    class: "width-180px",
                    searchKey: "l2_code",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "l2_code"
                },
                system: {
                    isVisible: true,
                    label: "System",
                    class: "width-180px",
                    searchKey: "system",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "system"
                },
                system_l2: {
                    isVisible: true,
                    label: "System L2",
                    class: "width-180px",
                    searchKey: "system_l2",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "system_l2"
                },
                average_useful_life_years: {
                    isVisible: true,
                    label: "Average Useful Life (Years)",
                    class: "width-180px",
                    searchKey: "average_useful_life_years",
                    type: "number",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "average_useful_life_years"
                },
                uniformat_code_l4: {
                    isVisible: true,
                    label: "Uniformat Code L4",
                    class: "width-180px",
                    searchKey: "uniformat_code_l4",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "uniformat_code_l4"
                },
                sub_system_l4: {
                    isVisible: true,
                    label: "Sub System L4",
                    class: "width-180px",
                    searchKey: "sub_system_l4",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "sub_system_l4"
                },
                uniformat_code_l5: {
                    isVisible: true,
                    label: "Uniformat Code L5",
                    class: "width-180px",
                    searchKey: "uniformat_code_l5",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "uniformat_code_l5",
                    isRequired: true
                },
                description: {
                    isVisible: true,
                    label: "Description",
                    class: "width-180px",
                    searchKey: "description",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "description"
                },
                unit: {
                    isVisible: true,
                    label: "Unit",
                    class: "width-180px",
                    searchKey: "unit",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "unit"
                },
                unit_cost: {
                    isVisible: true,
                    label: "Unit Cost",
                    class: "width-180px",
                    searchKey: "unit_cost",
                    type: "number",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "unit_cost"
                },
                regional_adj: {
                    isVisible: true,
                    label: "Regional Adjustment",
                    class: "width-180px",
                    searchKey: "regional_adj",
                    type: "number",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "regional_adj"
                },
                regionally_adjusted: {
                    isVisible: true,
                    label: "Regionally Adjusted",
                    class: "width-180px",
                    searchKey: "regionally_adjusted",
                    type: "number",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "regionally_adjusted"
                },
                action: {
                    isVisible: true,
                    label: "Action",
                    class: "width-180px",
                    searchKey: "action",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "action"
                },
                recommendation_name: {
                    isVisible: true,
                    label: "Recommendation Name",
                    class: "width-180px",
                    searchKey: "recommendation_name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "recommendation_name"
                },
                recommendation_narrative: {
                    isVisible: true,
                    label: "Recommendation Narrative",
                    class: "width-180px",
                    searchKey: "recommendation_narrative",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "recommendation_narrative"
                },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "width-180px",
                    searchKey: "created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "created_at",
                    hideInForm: true
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "width-180px",
                    searchKey: "updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "recommendation_assets_costing_templates",
                    commonSearchKey: "recommendation_assets_costing_templates",
                    commonSearchObjectKey: "updated_at",
                    hideInForm: true
                }
            }
        }
    },
    entity: {
        name: "Entity",
        key: "entity",
        responseKey: "survey_target",
        apiBodyParam: "entity",
        permissionKey: "entity",
        tableConfig: {
            keys: ["name", "description", "client", "created_at", "updated_at"],
            config: {
                name: {
                    isVisible: true,
                    label: "Name",
                    class: "",
                    searchKey: "survey_target.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "survey_target",
                    commonSearchKey: "survey_target",
                    commonSearchObjectKey: "name"
                },
                description: {
                    isVisible: true,
                    label: "Description",
                    class: "",
                    searchKey: "survey_target.description",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "survey_target",
                    commonSearchKey: "survey_target",
                    commonSearchObjectKey: "description"
                },
                client: {
                    isVisible: true,
                    label: "Client",
                    class: "",
                    searchKey: "clients.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "client_id",
                    commonSearchKey: "client_id",
                    // commonSearchObjectKey: "client",
                    commonFilterId: "client_id",
                    filterIdKey: "client_id"
                },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "",
                    searchKey: "survey_target.created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "survey_target",
                    commonSearchKey: "survey_target",
                    commonSearchObjectKey: "created_at"
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "",
                    searchKey: "survey_target.updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "survey_target",
                    commonSearchKey: "survey_target",
                    commonSearchObjectKey: "updated_at"
                }
            }
        }
    },
    client_standards_hierarchy: {
        name: "Client Standard Hierarchy",
        key: "client-standards-hierarchy",
        responseKey: "client_standards_hierarchy",
        apiBodyParam: "client_standards_hierarchy",
        permissionKey: "client_standard_hierarchy",
        tableConfig: {
            keys: ["client", "survey_target", "cs_l1_type", "cs_l2_category", "cs_l3_subsystem", "cs_l4_object", "name", "created_at", "updated_at"],
            config: {
                // name: {
                //     isVisible: true,
                //     label: "Name",
                //     class: "",
                //     searchKey: "client_standards.name",
                //     type: "string",
                //     hasWildCardSearch: true,
                //     hasCommonSearch: false,
                //     getListTable: "client_standards",
                //     commonSearchKey: "client_standards",
                //     commonSearchObjectKey: "name"
                // },
                client: {
                    isVisible: true,
                    label: "Client",
                    class: "",
                    searchKey: "clients.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "client_id",
                    commonSearchKey: "client_id",
                    // commonSearchObjectKey: "client",
                    commonFilterId: "client_id",
                    filterIdKey: "client_id"
                },
                survey_target: {
                    isVisible: true,
                    label: "Entity",
                    class: "",
                    searchKey: "survey_target.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "survey_target_id",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "survey_target",
                    commonFilterId: "survey_target_id",
                    filterIdKey: "survey_target_id"
                },
                cs_l1_type: {
                    isVisible: true,
                    label: "Type",
                    class: "",
                    searchKey: "cs_l1_types.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "cs_l1_type_id",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "cs_l1_types",
                    commonFilterId: "cs_l1_types",
                    filterIdKey: "cs_l1_types"
                },
                cs_l2_category: {
                    isVisible: true,
                    label: "Category",
                    class: "",
                    searchKey: "cs_l2_categories.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "cs_l2_category_id",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "cs_l2_categories",
                    commonFilterId: "cs_l2_categories",
                    filterIdKey: "cs_l2_categories"
                },
                cs_l3_subsystem: {
                    isVisible: true,
                    label: "Parent",
                    class: "",
                    searchKey: "cs_l3_subsystems.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "cs_l3_subsystem_id",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "cs_l3_subsystems",
                    commonFilterId: "cs_l3_subsystems",
                    filterIdKey: "cs_l3_subsystems"
                },
                cs_l4_object: {
                    isVisible: true,
                    label: "Object",
                    class: "",
                    searchKey: "cs_l4_objects.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "cs_l4_object_id",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "cs_l4_objects",
                    commonFilterId: "cs_l4_objects_id",
                    filterIdKey: "cs_l4_objects_id"
                },
                name: {
                    isVisible: true,
                    label: "Equipment Configuration",
                    class: "",
                    searchKey: "cs_l5_equipment_configs.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "cs_l5_equipment_config_id",
                    commonSearchKey: "cs_l5_equipment_configs",
                    commonSearchObjectKey: "cs_l5_equipment_config",
                    commonFilterId: "cs_l5_equipment_configs",
                    filterIdKey: "cs_l5_equipment_configs"
                },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "",
                    searchKey: "cs_l5_equipment_configs.created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "cs_l5_equipment_configs",
                    commonSearchKey: "cs_l5_equipment_configs",
                    commonSearchObjectKey: "created_at"
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "",
                    searchKey: "cs_l5_equipment_configs.updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "cs_l5_equipment_configs",
                    commonSearchKey: "cs_l5_equipment_configs",
                    commonSearchObjectKey: "updated_at"
                }
            }
        }
    },
    client_standards: {
        name: "Client Standard",
        key: "client-standards",
        responseKey: "client_standards",
        apiBodyParam: "client_standards",
        permissionKey: "client_standard",
        tableConfig: {
            keys: [
                "name",
                "description",
                "client",
                "uniformat_level_5s",
                "uniformat_level_6s",
                "survey_target",
                "cs_l1_type",
                "cs_l2_category",
                "cs_l3_subsystem",
                "cs_l4_object",
                "cs_l5_equipment_config",
                "in_scope",
                "comments",
                // "inactive",
                "created_at",
                "updated_at"
            ],
            config: {
                name: {
                    isVisible: true,
                    label: "Name",
                    class: "",
                    searchKey: "client_standards.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "client_standards",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "name"
                },
                description: {
                    isVisible: true,
                    label: "Description",
                    class: "",
                    searchKey: "client_standards.description",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "client_standards",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "description"
                },
                comments: {
                    isVisible: true,
                    label: "Comments",
                    class: "",
                    searchKey: "client_standards.comments",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "client_standards",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "comments"
                },
                client: {
                    isVisible: true,
                    label: "Client",
                    class: "",
                    searchKey: "clients.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "client_id",
                    commonSearchKey: "client_id",
                    // commonSearchObjectKey: "client",
                    commonFilterId: "client_id",
                    filterIdKey: "client_id"
                },
                uniformat_level_5s: {
                    isVisible: true,
                    label: "Uniformat Level 5",
                    class: "",
                    searchKey: "uniformat_level_5s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_5s",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "uniformat_level_5s",
                    commonFilterId: "uniformat_level_5s"
                    // filterIdKey: "uniformat_level_6s_id"
                },
                uniformat_level_6s: {
                    isVisible: true,
                    label: "Uniformat Level 6",
                    class: "",
                    searchKey: "uniformat_level_6s.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "uniformat_level_6s_id",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "uniformat_level_6s",
                    commonFilterId: "uniformat_level_6s_id",
                    filterIdKey: "uniformat_level_6s_id"
                },
                survey_target: {
                    isVisible: true,
                    label: "Entity",
                    class: "",
                    searchKey: "survey_target.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "survey_target_id",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "survey_target",
                    commonFilterId: "survey_target_id",
                    filterIdKey: "survey_target_id"
                },
                cs_l1_type: {
                    isVisible: true,
                    label: "Type",
                    class: "",
                    searchKey: "cs_l1_types.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "cs_l1_type_id",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "cs_l1_types",
                    commonFilterId: "cs_l1_types",
                    filterIdKey: "cs_l1_types"
                },
                cs_l2_category: {
                    isVisible: true,
                    label: "Category",
                    class: "",
                    searchKey: "cs_l2_categories.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "cs_l2_category_id",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "cs_l2_categories",
                    commonFilterId: "cs_l2_categories",
                    filterIdKey: "cs_l2_categories"
                },
                cs_l3_subsystem: {
                    isVisible: true,
                    label: "Parent",
                    class: "",
                    searchKey: "cs_l3_subsystems.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "cs_l3_subsystem_id",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "cs_l3_subsystems",
                    commonFilterId: "cs_l3_subsystems",
                    filterIdKey: "cs_l3_subsystems"
                },
                cs_l4_object: {
                    isVisible: true,
                    label: "Object",
                    class: "",
                    searchKey: "cs_l4_objects.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "cs_l4_object_id",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "cs_l4_objects",
                    commonFilterId: "cs_l4_objects",
                    filterIdKey: "cs_l4_objects"
                },
                cs_l5_equipment_config: {
                    isVisible: true,
                    label: "Equipment Configuration",
                    class: "",
                    searchKey: "cs_l5_equipment_configs.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "cs_l5_equipment_config_id",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "cs_l5_equipment_config",
                    commonFilterId: "cs_l5_equipment_config",
                    filterIdKey: "cs_l5_equipment_config"
                },
                in_scope: {
                    isVisible: true,
                    label: "In Scope",
                    class: "",
                    searchKey: "client_standards.in_scope",
                    type: "boolean",
                    hasWildCardSearch: true,
                    hasCommonSearch: true,
                    getListTable: "in_scope",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "in_scope"
                },
                // inactive: {
                //     isVisible: true,
                //     label: "In Active",
                //     class: "",
                //     searchKey: "client_standards.inactive",
                //     type: "boolean",
                //     hasWildCardSearch: true,
                //     hasCommonSearch: true,
                //     getListTable: "inactive",
                //     commonSearchKey: "inactive",
                //     commonSearchObjectKey: "inactive",
                //     commonFilterId: "inactive"
                // },
                created_at: {
                    isVisible: true,
                    label: "Created At",
                    class: "",
                    searchKey: "client_standards.created_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "client_standards",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "created_at"
                },
                updated_at: {
                    isVisible: true,
                    label: "Updated At",
                    class: "",
                    searchKey: "client_standards.updated_at",
                    type: "date",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "client_standards",
                    commonSearchKey: "client_standards",
                    commonSearchObjectKey: "updated_at"
                }
            }
        }
    },

    asset_dynamic_dictionary: {
        name: "Asset Dynamic Dictionary",
        key: "asset-dictionary",
        responseKey: "asset-dictionary",
        apiBodyParam: "asset-dictionary",
        permissionKey: "asset_dynamic_dictionary",
        isNotSideMenu: true,
        tableConfig: {
            keys: ["name", "client", "value"],
            config: {
                name: {
                    isVisible: true,
                    label: "Name",
                    class: "",
                    searchKey: "asset_dynamic_dictionary.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "name",
                    commonSearchKey: "name",
                    commonSearchObjectKey: "name",
                    isRequired: true
                },
                client: {
                    isVisible: true,
                    label: "Client",
                    class: "",
                    searchKey: "clients.name",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "clients.name",
                    commonSearchKey: "clients.name",
                    commonSearchObjectKey: "clients.name"
                },
                value: {
                    isVisible: true,
                    label: "Value",
                    class: "wide-value",
                    searchKey: "asset_dynamic_dictionary.value",
                    type: "string",
                    hasWildCardSearch: true,
                    hasCommonSearch: false,
                    getListTable: "value",
                    commonSearchKey: "value",
                    commonSearchObjectKey: "value",
                    isDynamicAddFieldColumn: true
                }
            }
        }
    }
};
export const MASTER_FILTER_KEYS = [{ label: "Clients", key: "clients", paramKey: "client_id" }];
